import React from 'react';
import RosterTables from '../components/RosterTables';

function Roster() {
  return <RosterTables />;
}

export default Roster;
